import { Size } from '@philips-emr/tws-constants';
import { ComponentAPI } from '@philips-emr/tws-core';
import { isEnumValid } from '@philips-emr/tws-utils';

class TextAPI extends ComponentAPI {

  getName(): string {
    return this.state.name;
  }

  setName(name: string): void {
    this.setState({ name });
  }

  getSize(): Size {
    return this.state.size;
  }

  setSize(size: Size): void {
    if (isEnumValid(Size, size)) {
      this.setState({ size });
    }
  }

  getValue(): string {
    return this.state.value;
  }

  setValue(value: string): void {
    this.setState({ value });
  }

}

export default TextAPI;
